/* eslint-disable @reatom/unit-naming-rule */
import { atom } from '@reatom/framework'

import type { Atom, CtxSpy } from '@reatom/framework'

export const atomWithPrev = <T>(
  computed: (ctx: CtxSpy, prev: T | undefined) => T,
  name?: string,
) => atom(computed, name) as unknown as Atom<T>
